import React from "react";
import { Box, Typography } from "@material-ui/core";
import Text from "../../../../shared/components/Text";
import { useTheme } from "@material-ui/styles";

export default function Slide2({ isScreenXs }) {
  const { palette } = useTheme();
  return (
    <Box mt={3} className={"appear-anim"}>
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography
          variant={isScreenXs ? "h5" : "h4"}
          align="center"
          style={{ color: palette.text.title }}
        >
          <strong>
            <Text tId="WHAT_IS_NEMURU" />
          </strong>
        </Typography>
      </Box>
      <Typography
        variant={"subtitle1"}
        align="center"
        style={{
          color: palette.text.title,
          lineHeight: "1.4",
          marginTop: "0.25rem",
        }}
      >
        <strong>
          <Text tId="NEMURU_INTRO" />
        </strong>
      </Typography>
      <Box mt={4}>
        <Typography
          align="center"
          variant={"body2"}
          style={{ color: palette.text.primary }}
        >
          <Text tId="NEMURU_INTRO_SUB" />
        </Typography>
      </Box>
    </Box>
  );
}
